import { createEnumParam } from 'use-query-params';
import { AuditLogSort, Direction, ScopeType, ValidationCheckReviewStatus } from './openapi-client';

export const SorterDirectionParams = createEnumParam(Object.values(Direction));
export const ValidationCheckReviewStatusParam = createEnumParam(Object.values(ValidationCheckReviewStatus));
export const AuditLogsSortParams = createEnumParam(Object.values(AuditLogSort));
export const ScopeTypeParams = createEnumParam(Object.values(ScopeType));
